<template>
<div class="banner-container">
    <div class="img"></div>
    <div class="banner">
        <h1>Welcome!</h1>
        <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
        <h3>You must be interested in becoming an Wave 2 Officer for MISA 2023-2024 if you’re here. We can’t wait to work with you! </h3>
        <button @click="$router.push('/apply')" class="primary-btn home-ctas">Apply Now</button>
    </div>
    
    <!-- <button></button> -->
</div>
    
</template>

<script>
export default {
    name: 'Banner'
}
</script>

<style scoped>
  
    

    .banner{
        max-width: 720px;
        font-weight: 300;
        line-height: 30px;
        padding-top:96px;
        padding-bottom: 96px;
        /* padding: 216px 0px; */
        align-self: flex-start;
    }

    .banner-container{
        /* margin-top: 80px; */
        width: 100%;
        overflow-x: hidden;
        display: flex;
        flex-flow: row-reverse nowrap;
        justify-content: space-around;
    }

    

    @media only screen and (max-width: 1353px) {
        .img{
            max-width: 32vw;
            height: 40vw;
            background-position: center center;
            /* flex-grow: 1; */
        }
    }

    @media only screen and (max-width: 768px) {
        
        .banner-container{
            padding-top: 0px;
            flex-direction: column;
        }

        .img{
            max-width: 0;
            height: 0;
            /* background-position: bottom center;
            background-size: contain; */
            align-self: flex-end;
            display: none;
        }
    }


    .img{
        /* max-width: 490px; */
        max-height: 400px;
        width: 32vw;
        /* height:18vw; */
        /* height: auto; */
        display: block;
        background: url('~@/assets/homemain.png') no-repeat;
        background-size: 100% auto;
        background-position: bottom center;
        /* transform: translate(50px 0px); */
    }

    h1, h3{
        margin-bottom: 48px;
    }
</style>


